export const modalStyle = {
  content: {
    borderRadius: "2px",
    display: "block",
    margin: "48px 0 80px",
    overflow: "hidden",
    position: "relative",
    inset: "40px 0px"
  },
  overlay: {
    alignItems: "flex-start",
    display: "flex",
    height: "100%",
    justifyContent: "center",
    left: 0,
    overflowY: "auto",
    position: "fixed",
    top: 0,
    width: "100%",
    zIndex: 1111,
    backgroundColor: "rgba(0,0,0,.4)"
  }
};
export const modalStyleCenter = {
  content: {
    borderRadius: "2px",
    margin: "25vh 0 80px",
    display: "block",
    overflow: "hidden",
    position: "relative",
    inset: "0px",
    borderRadius: "8px",
    padding: "0px",
    width: "100%",
    maxWidth: "600px"
  },
  overlay: {
    alignItems: "flex-start",
    display: "flex",
    height: "100%",
    justifyContent: "center",
    left: 0,
    overflowY: "auto",
    position: "fixed",
    top: 0,
    width: "100%",
    zIndex: 1111,
    backgroundColor: "rgba(0,0,0,.4)"
  }
};
export const modalStyleDetail = {
  content: {
    width: "100%",
    height: "100%",
    inset: "0px",
    display: "block",
    overflow: "hidden",
    position: "relative",
    border: "none",
    maxWidth: "600px",
    padding: "0px",
    borderRadius: "0px",
  },
  overlay: {
    border: "none",
    padding: "0px",
    alignItems: "flex-start",
    display: "flex",
    height: "100%",
    justifyContent: "center",
    left: 0,
    overflowY: "auto",
    position: "fixed",
    top: 0,
    width: "100%",
    zIndex: 1111,
    backgroundColor: "rgba(0,0,0,.4)"
  }
};

export const modalNOVFContent = {
  content: {
    borderRadius: "2px",
    display: "block",
    margin: "48px 0 80px",
    overflow: "none",
    position: "relative"
  },
  overlay: {
    alignItems: "flex-start",
    display: "flex",
    height: "100%",
    justifyContent: "center",
    left: 0,
    overflowY: "auto",
    position: "fixed",
    top: 0,
    width: "100%",
    zIndex: 1111,
    backgroundColor: "rgba(0,0,0,.4)"
  }
};
export const modalStyleBottom = {
  content: {
    display: "block",
    overflow: "hidden",
    position: "relative",
    width: "100%",
    borderRadius: "8px 8px 0px 0px",
    border: "none",
    padding: "0px",
    maxWidth: "600px",
    maxHeight: "100%",
    position: "fixed",
    top: "auto",
    right: "auto",
    left: "auto",
    bottom: 0,
    overflow: "auto"
  },
  overlay: {
    alignItems: "flex-start",
    display: "flex",
    height: "100%",
    justifyContent: "center",
    overflowY: "auto",
    position: "fixed",
    bottom: 0,
    width: "100%",
    zIndex: 1111,
    backgroundColor: "rgba(0,0,0,.4)"
  }
};

export const style = {
  height: "100%",
  marginRight: "auto",
  marginLeft: "auto",
  overflow: "auto",
  maxWidth: "600px",
  bgcolor: "#F6F6F6",
  position: "relative",
  outline: "none"
};
